import React, { useState } from 'react';
import Key from './key.js';
import './piano.css';
import { allNotes } from '../constants.js';
import _ from 'lodash';

function Piano() {
  const [pressed, setPressed] = useState([]);
  function handleKeyDown(e) {
    if (e.repeat) return;
    setPressed(e.key, ...pressed);
  }
  function handleKeyUp(e) {
    const index = pressed.indexOf(e.key);
    if (index > -1) setPressed(pressed.slice(index, 1));
  }
  window.addEventListener('keydown', handleKeyDown);
  window.addEventListener('keyup', handleKeyUp);
  let allKeys = _.map(allNotes, (note, index) => {
    return (
        <Key key={index} note={note} pressedKeys={pressed}/>
    );
  });
  return (
    <div className='piano'>
        {allKeys}
    </div>
  );
}

export default Piano